import React from "react";
import { connect } from "react-redux";
import WeatherMoratorium from "../components/WeatherMoratorium";
import selectWeatherMoratoriumContainer from "../selectors/weatherMoratorium";

import {
  getWeatherMoratorium,
  getTDSPCounties,
  createWeatherMoratorium,
  updateWeatherMoratorium,
} from "../actions/weatherMoratorium";

const WeatherMoratoriumContainer = (props) => <WeatherMoratorium {...props} />;

const mapStateToProps = (state) => ({
  ...selectWeatherMoratoriumContainer(state)(state),
});

const mapDispatchToProps = (dispatch) => ({
  doFetchWeatherMoratorium: () => {
    dispatch(getWeatherMoratorium());
  },
  doFetchCreateWeatherMoratorium: form => {
    dispatch(createWeatherMoratorium(form));
  },
  doFetchUpdateWeatherMoratorium: form => {
    dispatch(updateWeatherMoratorium(form));
  },
  doFetchGetTDSPCounties: () => {
    dispatch(getTDSPCounties());
  },
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(WeatherMoratoriumContainer);
